<template>
  <el-dropdown @command="handleCommand" class="dropdown">
    <span class="el-dropdown-link">
      {{ getCommandText }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in this.timeZones" :key="item.key" :command="item.key">
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { LOCALE_STORE_KEY } from '../constant'
import { setLocal, getLocal } from '@meta-vue/util'
export default {
  props: ['localesResult'],
  computed: {
    getCommandText() {
      return this.timeZones.find(item => item.key === (this.zoneCommand || ''))?.label || ''
    }
  },
  data() {
    return {
      timeZones: [],
      zoneCommand: '', //时区
      command: '' //国家
    }
  },
  created() {},
  methods: {
    handleCommand(zoneCommand) {
      this.zoneCommand = zoneCommand
      const locales = getLocal(LOCALE_STORE_KEY)
      setLocal(
        LOCALE_STORE_KEY,
        { country: locales.country, lang: locales.lang, timeZone: this.zoneCommand },
        { expire: 1000 * 60 * 60 * 24 * 365 }
      )
      window.location.reload()
    }
  },
  watch: {
    localesResult(value) {
      const locales = getLocal(LOCALE_STORE_KEY)
      this.command = locales.country
      this.zoneCommand = locales.timeZone
      this.timeZones = this.localesResult.find(item => item.country.key === this.command).timeZones
    }
  }
}
</script>

<style lang="stylus" scoped>
.dropdown {
  cursor: pointer;
}
</style>
